import type { SystemStyleObject } from '@chakra-ui/react'

import { fontFamilies } from '../../theme/fontFamilies'
import type { ColorScheme } from '../../types'

export const facilityPillStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  bg: colorScheme === 'light' ? 'light.bg.chip-secondary' : 'bg.chip-secondary',
  color:
    colorScheme === 'light'
      ? 'light.text.chip-secondary'
      : 'text.chip-secondary',
  maxWidth: '100%',
  minWidth: 0,
  overflow: 'hidden',
  fontFamily: fontFamilies.soehneKraftig,
  fontSize: '14px',
  fontWeight: '500',
})
